import { combineReducers } from "redux";

import persist from "./persist";
import user from "./user";
import banners from "./banners";
import content from "./content";
import languages from "./languages";
import locations from "./locations";
import faq from "./faq";
import reviewsEmail from "./reviewsEmail";
import managers from "./managers";
import news from "./news";
import newsPagination from "./newsPagination";
import newsItem from "./newsItem";
import pastReviews from "./pastReviews";
import sort from "./sort";
import reviewers from "./reviewers";
import route from "./route";
import translations from "./translations";
import salutations from "./salutations";
import colorStatuses from "./colorStatuses";
import organizations from "./organizations";
import sectors from "./sectors";
import siteInfo from "./siteInfo";
import profileTypes from "./profileTypes";
import phoneTypes from "./phoneTypes";
import profileStatuses from "./profileStatuses";
import training from "./training";
import trainingDocs from "./trainingDocs";
import trainingEducation from "./trainingEducation";
import trainingVideos from "./trainingVideos";
import reviews from "./reviews";
import registered from "./registered";
import registration from "./registration";
import reviewSearch from "./reviewSearch";
import reviewerSearch from "./reviewerSearch";
import sectorSuggestions from "./sectorSuggestions";
import userTypes from "./userTypes";

// Combine reducers
const rootReducer = combineReducers({
	persist,
	user,
	banners,
	content,
	languages,
	locations,
	faq,
	reviewsEmail,
	managers,
	news,
	newsPagination,
	newsItem,
	pastReviews,
	sort,
	reviewers,
	route,
	translations,
	colorStatuses,
	salutations,
	organizations,
	sectors,
	siteInfo,
	profileTypes,
	phoneTypes,
	profileStatuses,
	training,
	trainingDocs,
	trainingEducation,
	trainingVideos,
	reviews,
	registered,
	registration,
	reviewerSearch,
	reviewSearch,
	sectorSuggestions,
	userTypes
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js